var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossWhiteFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 8.49967C1.33301 4.81778 4.31778 1.83301 7.99967 1.83301C11.6816 1.83301 14.6663 4.81778 14.6663 8.49967C14.6663 12.1816 11.6816 15.1663 7.99967 15.1663C4.31778 15.1663 1.33301 12.1816 1.33301 8.49967Z",
    fill: "#FC5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52827 6.02827C5.78862 5.76792 6.21073 5.76792 6.47108 6.02827L7.99967 7.55687L9.52827 6.02827C9.78862 5.76792 10.2107 5.76792 10.4711 6.02827C10.7314 6.28862 10.7314 6.71073 10.4711 6.97108L8.94248 8.49967L10.4711 10.0283C10.7314 10.2886 10.7314 10.7107 10.4711 10.9711C10.2107 11.2314 9.78862 11.2314 9.52827 10.9711L7.99967 9.44248L6.47108 10.9711C6.21073 11.2314 5.78862 11.2314 5.52827 10.9711C5.26792 10.7107 5.26792 10.2886 5.52827 10.0283L7.05687 8.49967L5.52827 6.97108C5.26792 6.71073 5.26792 6.28862 5.52827 6.02827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossWhiteFull);
export default __webpack_public_path__ + "static/media/cross-white-full.e668833a.svg";
export { ForwardRef as ReactComponent };